export const buttonOptions = {
	className: '',
	label: '',
	onClick: '',
	type: '',
	id: '',
	borderColor: '',
	style: '',
	tabIndex: 0,
	themeColor: '',
	themeTextColor: '',
	applyOnHover: false,
};
